import "@firebase/firestore";
import firebase from "./init";

export default firebase.firestore();
